module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='  <div class="headerBar">\n    <div class="headerButtonBar">\n    </div>\n  </div>\n\n  <div class="innerContent validation-info-div">\n      <span>\n        <a target="_blank" href="https://docs.arangodb.com/'+
((__t=(parsedVersion))==null?'':__t)+
'/concepts/data-structure/documents/schema-validation/" class="button-warning button-help-inline"><i class="fa fa-question-circle" style="margin-left: auto;"></i> Help</a>\n      </span>\n      <div id="validationEditor"> </div>\n      <div class="bottomButtonBar">\n        <button id="saveValidationButton" class="pull-right button-success">Save</button>\n      </div>\n  </div>\n';
}
return __p;
};
